import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Container, Row, Col, Modal, Form, Button, Table, Accordion, Badge, InputGroup, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPencil, faTrash, faStar, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select'
import { ReactComponent as PlusIcon } from "../../../../assets/images/icon_svg/plus.svg";
import { ReactComponent as WhiteEmail } from "../../../../assets/images/icon_svg/white_mail.svg";
import { ReactComponent as AirlineLogo } from "../../../../assets/images/icon_svg/airlineLogo.svg";
import { ReactComponent as Attach } from "../../../../assets/images/icon_svg/attach.svg";
import { ReactComponent as Developed } from "../../../../assets/images/icon_svg/development.svg";
import { ReactComponent as WhitePlane } from "../../../../assets/images/icon_svg/white_plane.svg";
import { ReactComponent as MoreOption } from "../../../../assets/images/icon_svg/moreOption_icon.svg";

import { ReactComponent as RedEmail } from "../../../../assets/images/icon_svg/redEmail.svg";
import { ReactComponent as GreenEmail } from "../../../../assets/images/icon_svg/green_mail.svg";
import { ReactComponent as Map } from "../../../../assets/images/icon_svg/map.svg";
import { ReactComponent as Files } from "../../../../assets/images/icon_svg/file.svg";
import '../../../../assets/css/s_recovery/communication/communication.css';
import { CommonModal } from '../../../../Components/common/CommonFunctions';

const Communication = ({ propData, onReload }) => {
  const [mailModal, setMailModal] = useState(false);
  console.log('propData', propData);

  const handleAddEmail = (data) => {
    setMailModal(true)
    // setSendData(data)
  }

  const modalClose = () => {
    setMailModal(false)
  }
  const sendEmail = () => {

  }
  return (
    <>
      <div className='d-flex justify-content-between gap-3'>
        <div className='tw-30'>
          <div className='mb-2'>
            <button className='prm_btn w-100' onClick={handleAddEmail}><WhiteEmail className='pe-1'/>Create New Email</button>
          </div>
          <div className='summary_card th-82'>
            <button className='dark_btn'>
              All
            </button>
            <button className='transparent_btn'>
              Origin (AMS) - Dnata
            </button>
            <button className='transparent_btn'>
              Station (BRE) - WFS
            </button>
            <button className='transparent_btn'>
              Destination (HKG) - Swissport
            </button>
            <hr />
            <div className='search_dv'>
              <InputGroup className="mb-3">
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </InputGroup.Text>

                <Form.Control
                  type="text"
                  placeholder="Search Mail"
                  className='searchFrmControl'

                />
              </InputGroup>
            </div>
            <div className='mailInbxLstWrap max-hgt-50'>
              <div className='mailInbxLst activemailInbxLst'>
                <AirlineLogo />
                <div className='mailBdy'>
                  <h6>Swissport Recovery</h6>
                  <span>Recovery of Shipment</span>
                  <p>Dear Emirates, Hereby we inform...</p>
                </div>

              </div>
              <div className='mailInbxLst'>
                <AirlineLogo />
                <div className='mailBdy'>
                  <h6>Swissport Recovery</h6>
                  <span>Recovery of Shipment</span>
                  <p>Dear Emirates, Hereby we inform...</p>
                </div>

              </div>
            </div>
          </div>
          <div>

          </div>
        </div>
        <div className='tw-70 summary_card th-88'>
          <div className='d-flex position-relative gap-3 border_bottom'>
            <AirlineLogo />
            <div className='mailBdy'>
              <h6>Swissport Recovery</h6>
              <span>swissport.recovery@swissport.com</span>
              <p>Subject : Recovery of Shipment 167-1652 1560</p>
            </div>
            <Link className='MoreOption'><MoreOption /></Link>
          </div>
          <div className='min-hgt-45 mb-4'>
            <div className='commonrghtCht d-flex gap-3 w-75 mb-3'>
              <div className='chtbdy'>
                <p>Dear Swissport Recovery Team, </p>
                <p>Thank you for the update and confirmation of recovery.</p>
                <p>Please prepare the shipment for uplift on the next available Emirates flight and share the updated flight details once confirmed.</p>
                <p> Kind regards, Emirates SkyCargo Operations </p>
              </div>
              <div className='text-right'>
                <AirlineLogo />
              </div>
            </div>
            <div className='commonlftCht d-flex gap-3 w-75'>
              <div className='text-right'>
                <AirlineLogo />
              </div>
              <div className='chtbdy Chatbg'>
                <p>Dear Emirates Cargo Team,</p>
                <p>We would like to provide an update regarding the recovery process of shipment AWB 176-98345671, which was previously reported as missing during handling operations.</p>
                <p>Following an internal warehouse search and coordination with our ramp and documentation teams, the shipment has been successfully located at the Swissport warehouse facility. The cargo was identified during a stock reconciliation process and verified against the handling records.</p>
                <p>The shipment is currently secured and pending further instructions. Please advise whether the cargo should be prepared for uplift on the next available flight or held for collection.</p>
                <p>Should you require any additional information or documentation, please do not hesitate to contact us.</p>
                <p>Kind regards,Swissport Service Recovery Team</p>
              </div>
            </div>
          </div>

          <div>
            <Form.Control
              as="textarea"
              placeholder="Reply to email"
              rows={4}
              className="mb-3 replyToEmail"
              style={{ resize: 'none' }}
            />
            <div className="d-flex align-items-center justify-content-between">
              <div className='d-flex align-items-center gap-2'>
                <div className="d-flex align-items-center gap-2">
                  <Button className="d-flex align-items-center gap-2 px-4 prm_btn"><WhitePlane />Send</Button>
                </div>
                <div>
                  <Attach />
                </div>
                <div>
                  <Files />
                </div>
                <div>
                  <Developed />
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                <Form.Check
                  type="checkbox"
                  id="auto-set-checkbox"
                  className="m-0 green_check"
                />
                <Form.Label
                  htmlFor="auto-set-checkbox"
                  className="m-0 mailchckbxtxt"
                  style={{ cursor: 'pointer' }}
                >
                  Automatically set case to 'Awaiting Response' after send
                </Form.Label>
              </div>
            </div>
          </div>

        </div>
      </div>

      {mailModal &&
        <CommonModal
          show={mailModal}
          onHide={modalClose}
          title={`Create Tracing Mail - ${propData?.master_airway_bill_prefix}-${propData?.master_airway_bill_no}`}
          subTitle='Send communication linked to recovery case'
          className='modal_bgw primary_modal srCrtmail'
          footer={
            <div className='d-flex justify-content-between w-100'>
              <div></div>
              <Button variant="primary" className='defult_save' onClick={sendEmail}>
                Send
              </Button>
            </div>
          }>

          <Form.Group>
            <Form.Label>Email Recipients (Select Stations)</Form.Label>
            {/* <div className='d-flex flex-wrap Email_RecipientsDv gap-2'>
              {propData?.all_routing?.map((stn, index) => (
                <div className='d-flex gap-2' key={`stn_${index}`}>
                  <Form.Check
                    type="checkbox"
                  // checked={reportId === 1}
                  // onChange={() => checkReported(1)}
                  />
                  <div>
                    <p className='d-block'>{stn.station_code} - {stn.handler_type}</p>
                    <span>{stn.handler_name ?? '-'}</span>
                  </div>
                  {stn.is_reported ? <div><Map /></div> : <></>}
                  {stn.handler_contact?.additional_emails?.length === 0 ? <RedEmail /> : <GreenEmail />}
                </div>
              ))}
            </div> */}
            <div className='d-flex flex-wrap Email_RecipientsDv'>
              {propData?.all_routing?.map((stn, index) => (
                <div className='recipient_card' key={`stn_${index}`}>

                  <Form.Check
                    type="checkbox"
                    className="recipient_checkbox"
                  />

                  <div className='recipient_content'>
                    <p className='recipient_title'>
                      {stn.station_code} - {stn.handler_type}
                    </p>
                    <span className='recipient_subtitle'>
                      {stn.handler_name ?? '-'}
                    </span>
                  </div>

                  <div className='recipient_icons'>
                    {stn.is_reported && <Map />}
                    {stn.handler_contact?.additional_emails?.length === 0
                      ? <RedEmail />
                      : <GreenEmail />}
                  </div>

                </div>
              ))}
            </div>
            <hr />
            <Form.Label>Email Template</Form.Label>
            <Select
              options={[]}
              onChange={(selected) => {

              }}
              placeholder="Station"
              className='autoslct w-100 p-0'
              name=''
            // value={getDestination.find(option => option.value === station.station) || ''}
            />
          </Form.Group>

        </CommonModal>
      }
    </>
  )
}

export default Communication